import React from "react";

import { Box, Button, Typography, useTheme } from "@mui/material";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import { useNavigate } from "react-router-dom";

export default function NotFoundPage() {
  const theme = useTheme();
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        textAlign: "center",
        px: 3,
        backgroundColor: theme.palette.background.default,
      }}
    >
      <img
        src="/logo.png"
        alt="Podcast Assistant"
        style={{
          width: 56,
          height: 56,
          marginBottom: 24,
          objectFit: "contain",
        }}
      />

      <Typography
        sx={{
          fontSize: { xs: 72, sm: 96 },
          fontWeight: 800,
          lineHeight: 1,
          letterSpacing: "-0.04em",
          color: theme.palette.primary.main,
        }}
      >
        404
      </Typography>

      <Typography
        sx={{
          mt: 2,
          fontSize: { xs: "1.25rem", sm: "1.5rem" },
          fontWeight: 700,
          color: theme.palette.text.primary,
        }}
      >
        Page not found
      </Typography>

      <Typography
        sx={{
          mt: 1,
          maxWidth: 420,
          color: theme.palette.text.secondary,
          lineHeight: 1.6,
        }}
      >
        The page you&apos;re looking for doesn&apos;t exist or may have been
        moved.
      </Typography>

      <Button
        variant="contained"
        startIcon={<HomeOutlinedIcon />}
        onClick={() => navigate("/episodes")}
        sx={{
          mt: 4,
          px: 3,
          py: 1,
          borderRadius: "8px",
          fontWeight: 600,
          textTransform: "none",
        }}
      >
        Back to Episodes
      </Button>
    </Box>
  );
}
